import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import MiniPDPAnalyticsMiddleware from 'yoda-mini-pdp/lib/middlewares/MiniPDPAnalyticsMiddleware';
import MarketingMiddleware from './MarketingMiddleware';
import CJAMiddleware from './CJAMiddleware';

const rootMiddleware = [
    CommonMiddleware,
    MarketingMiddleware,
    CJAMiddleware,
    MiniPDPAnalyticsMiddleware,
];

export default rootMiddleware;
